var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12476 13.432L5.92676 13.546L5.92696 13.3176C5.92696 13.3176 5.92416 13.4344 5.9769 13.4637C6.02858 13.4922 6.12476 13.432 6.12476 13.432Z",
    fill: "#8E3315"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.04395 13.199C2.15973 15.3046 4.06806 16.8814 6.34911 17.5828C8.63019 18.2843 11.0972 18.0528 13.2073 16.9394C15.3175 15.8258 16.898 13.9215 17.6011 11.6452C18.3042 9.36887 18.0676 6.9071 16.9518 4.80151C17.9579 7.96587 14.455 9.07755 14.455 9.07755L10.2154 11.2887L5.80931 13.582C5.80931 13.582 2.80631 15.5112 1.04395 13.199Z",
    fill: "#473ADE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02832 13.213C2.1441 15.3187 4.05243 16.8957 6.33352 17.5972C8.61461 18.2987 11.0815 18.0673 13.1917 16.9537C15.3019 15.8402 16.8823 13.9358 17.5854 11.6595C18.2886 9.38312 18.0568 6.92134 16.941 4.81567C17.9471 7.98014 14.4394 9.0918 14.4394 9.0918L10.1998 11.303L5.79368 13.5963C5.79368 13.5963 2.79068 15.5252 1.02832 13.213Z",
    fill: "url(#paint0_linear_65_618)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3429 8.85791L14.6702 9.0169L14.3247 9.1555C14.3247 9.1555 14.4729 9.08553 14.4906 9.0169C14.5079 8.9497 14.3429 8.85791 14.3429 8.85791Z",
    fill: "#251E73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0068 13.1041C18.0963 10.9849 18.2976 8.52045 17.5663 6.25298C16.835 3.98556 15.231 2.10083 13.1073 1.01344C10.9835 -0.0739511 8.51384 -0.274942 6.24161 0.454684C3.96942 1.18431 2.0808 2.78479 0.991211 4.90406C3.01307 2.26762 5.9363 4.49895 5.9363 4.49895L10.1819 6.69866L14.5904 8.98743C14.5904 8.98743 17.8954 10.3377 17.0068 13.1041Z",
    fill: "#D71D6A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.985 13.0954C18.0713 10.9825 18.272 8.52539 17.5429 6.2647C16.8137 4.00403 15.2146 2.12492 13.0971 1.04077C10.9796 -0.043389 8.51729 -0.243781 6.25189 0.483671C3.98643 1.21113 2.10343 2.80684 1.01709 4.91975C3.03293 2.29122 5.94748 4.51589 5.94748 4.51589L10.1804 6.709L14.5757 8.99103C14.5757 8.99103 17.871 10.3372 16.985 13.0954Z",
    fill: "url(#paint1_linear_65_618)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92797 4.71255L5.92432 4.47339L6.13337 4.58972C6.13337 4.58972 6.02781 4.52779 5.97421 4.56115C5.92176 4.59386 5.92797 4.71255 5.92797 4.71255Z",
    fill: "#741039"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99967 0.020752C6.61283 0.0207524 4.3237 0.967024 2.63594 2.6514C0.948173 4.33576 4.54563e-07 6.62026 0 9.00233C0 11.3844 0.948173 13.6689 2.63594 15.3533C4.3237 17.0376 6.61283 17.9839 8.99967 17.9839C5.93634 17.4706 5.93634 13.5101 5.93634 13.5101V9.00233V4.41483C5.93634 4.41483 5.93634 0.567908 8.99967 0.020752Z",
    fill: "#FF5B25"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99967 0C6.61283 0 4.3237 0.946272 2.63594 2.63064C0.948177 4.31501 4.54563e-07 6.59951 0 8.98158C0 11.3636 0.948173 13.6482 2.63594 15.3325C4.3237 17.0169 6.61283 17.9631 8.99967 17.9631C5.9363 16.9865 5.9363 13.5152 5.9363 13.5152V8.9927V4.49895C5.9363 4.49895 5.82489 0.582032 8.99967 0Z",
    fill: "url(#paint2_linear_65_618)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99967 0C6.61283 0 4.3237 0.946272 2.63594 2.63064C0.948177 4.31501 4.54563e-07 6.59951 0 8.98158C0 11.3636 0.948173 13.6482 2.63594 15.3325C4.3237 17.0169 6.61283 17.9631 8.99967 17.9631C5.9363 16.9865 5.9363 13.5152 5.9363 13.5152V8.9927V4.49895C5.9363 4.49895 5.82489 0.582032 8.99967 0Z",
    fill: "url(#paint3_linear_65_618)",
    fillOpacity: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97585 17.979C5.93613 16.5974 5.9397 13.5129 5.9397 13.5129C5.9397 13.5129 2.17216 15.6337 0.903809 12.9211C0.903809 12.9211 3.03001 17.997 8.97585 17.979Z",
    fill: "#473ADE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_65_618",
    x1: 16.9417,
    y1: 7.97799,
    x2: 3.87359,
    y2: 20.9073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655513,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_65_618",
    x1: 3.60571,
    y1: 3.11222,
    x2: 21.6492,
    y2: 6.42942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_65_618",
    x1: 4.81957,
    y1: 16.8505,
    x2: -0.514153,
    y2: 0.387949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675464,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_65_618",
    x1: 4.81957,
    y1: 16.8505,
    x2: -0.514153,
    y2: 0.387949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675464,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLogo);
export default __webpack_public_path__ + "static/media/mini-logo.64d5354d68895a8c4f9671940689af6a.svg";
export { ForwardRef as ReactComponent };